export const ROOT = '/';
export const PRIVACY_POLICY = 'privacy-policy';
export const TERMS_AND_CONDITION = 'terms-and-conditions';
